/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify === "undefined") {
    window.Shopify = {};
}

Shopify.bind = (fn, scope) =>
    function () {
        // biome-ignore lint/complexity/noArguments: tvg
        return fn.apply(scope, arguments);
    };

Shopify.setSelectorByValue = (selector, value) => {
    for (let i = 0, count = selector.options.length; i < count; i++) {
        const option = selector.options[i];
        if (value === option.value || value === option.innerHTML) {
            selector.selectedIndex = i;
            return i;
        }
    }
};

Shopify.addListener = (target, eventName, callback) => {
    target.addEventListener
        ? target.addEventListener(eventName, callback, false)
        : target.attachEvent(`on${eventName}`, callback);
};

Shopify.postLink = (path, options) => {
    options = options || {};
    const method = options.method || "post";
    const params = options.parameters || {};

    const form = document.createElement("form");
    form.setAttribute("method", method);
    form.setAttribute("action", path);

    for (const key in params) {
        const hiddenField = document.createElement("input");
        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", key);
        hiddenField.setAttribute("value", params[key]);
        form.appendChild(hiddenField);
    }
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
    country_domid,
    province_domid,
    options,
) {
    this.countryEl = document.getElementById(country_domid);
    this.provinceEl = document.getElementById(province_domid);
    this.provinceContainer = document.getElementById(
        options.hideElement || province_domid,
    );

    Shopify.addListener(
        this.countryEl,
        "change",
        Shopify.bind(this.countryHandler, this),
    );

    this.initCountry();
    this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
    initCountry: function () {
        const value = this.countryEl.getAttribute("data-default");
        Shopify.setSelectorByValue(this.countryEl, value);
        this.countryHandler();
    },

    initProvince: function () {
        const value = this.provinceEl.getAttribute("data-default");
        if (value && this.provinceEl.options.length > 0) {
            Shopify.setSelectorByValue(this.provinceEl, value);
        }
    },

    countryHandler: function (_e) {
        const opt = this.countryEl.options[this.countryEl.selectedIndex];
        const raw = opt.getAttribute("data-provinces");
        const provinces = JSON.parse(raw);

        this.clearOptions(this.provinceEl);
        if (provinces && provinces.length === 0) {
            this.provinceContainer.style.display = "none";
        } else {
            for (let i = 0; i < provinces.length; i++) {
                const optEl = document.createElement("option");
                optEl.value = provinces[i][0];
                optEl.innerHTML = provinces[i][1];
                this.provinceEl.appendChild(optEl);
            }

            this.provinceContainer.style.display = "";
        }
    },

    clearOptions: (selector) => {
        while (selector.firstChild) {
            selector.removeChild(selector.firstChild);
        }
    },

    setOptions: (selector, values) => {
        for (let i = 0, _count = values.length; i < values.length; i++) {
            const opt = document.createElement("option");
            opt.value = values[i];
            opt.innerHTML = values[i];
            selector.appendChild(opt);
        }
    },
};
